module.exports = __webpack_public_path__ + "img/chat_head.e915f79d.png";